<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <template v-if="qa_categories">
          <h1 class="text-title-underline">過去の質疑応答（テキスト）</h1>
          <p>過去にあった会員さんからのご質問と山根先生の回答をまとめています。</p>
          <p>講座やワークでつまづいた時は、ぜひ参考になさってみてください。</p>
          <p>下記をクリックすると、カテゴリごとのQ&A一覧が表示されます。</p>
          <p class="mt-5 font-bold text-gray-500 mb-2">カテゴリ一覧</p>
          <ul class="card-outlined md:py-2 md:px-4">
            <li v-for="qa_category in qa_categories" :key="qa_category.id" class="px-1 pt-1.5 pb-2">
              <div class="px-2 mb-2 max-w-md">
                <div class="w-ful">
                  <div class="text-lg font-bold">{{qa_category.name}}</div>
                  <ul class="md:py-2 md:px-4">
                    <li v-for="qa_sub_category in qa_category.qa_sub_categories" :key="qa_sub_category.id" class="px-1 pt-1.5 pb-2">
                      <router-link
                        :to="`/qa/category/`+ qa_sub_category.id"
                      >
                        <div class="flex items-center justify-between border-gray-300 border-b px-2 mb-2">
                          <div class="text-green-600 hover:text-green-400">
                            {{qa_sub_category.name}}
                          </div>
                        </div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </template>
        <template v-else>
          ページが見つかりませんでした。
        </template>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { useStore } from '@/store/index'
import { useRoute } from 'vue-router'
import { axios, ApiResponse } from '@/plugins/axios'
// import { QAListAttributes } from '@/types/models/qa-list'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth
  },
  setup() {
    const store = useStore()
    const qa_categories = ref()

    onMounted(() => {
      axios
        .get('/qa/category')
        .then(response => {
          qa_categories.value = response.data.payload
        })
    })

    return {
      store,
      qa_categories
    }
  }
})
</script>
